(() => {
    const CRYPTO_METRIKA = Object.freeze({
        counterId: 46008906,
        get counter() {
            return window[`yaCounter${this.counterId}`];
        },
    });

    window.CRYPTO_METRIKA = CRYPTO_METRIKA;
    window.cryptoReachGoal = (goal) => {
        if (typeof goal !== 'string' || !goal.trim()) {
            return;
        }

        try {
            const counter = CRYPTO_METRIKA.counter;
            if (typeof counter?.reachGoal === 'function') {
                counter.reachGoal(goal);
            } else if (typeof window.ym === 'function') {
                window.ym(CRYPTO_METRIKA.counterId, 'reachGoal', goal);
            }
        } catch {
            // Analytics must never interrupt navigation or other click handlers.
        }
    };
})();
